import Chart from 'chart.js';
import classNames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import round from 'lodash/round';
import sum from 'lodash/sum';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsSales} from '../../../../../actions/entities/statistics/sales';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../components/Loader';
import {getIncrease} from '../../../../../helpers/stats';
import './index.css';

// Maybe some day use a translation package on this project ?
const translations = {
  android: 'Android',
  ios: 'iOS',
  seeds: 'Graines',
  stripe: 'Stripe',
};

let chart1;
let chart2;

class SalesWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start, lang: 'ALL'};
  }

  fetchStats() {
    const {end, start} = this.state;
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsSales(
          {
            endDate: moment(end).format('YYYY-MM-DD'),
            startDate: moment(start).format('YYYY-MM-DD'),
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  componentDidMount() {
    if (document.getElementById('totalCaByPlatform-chart'))
      chart1 = new Chart(document.getElementById('totalCaByPlatform-chart'), {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
    if (document.getElementById('totalPurchasesByProduct-chart'))
      chart2 = new Chart(
        document.getElementById('totalPurchasesByProduct-chart'),
        {
          type: 'bar',
          data: {datasets: []},
          options: {
            scales: {
              xAxes: [
                {
                  id: 'date',
                  type: 'time',
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  id: 'members',
                  type: 'linear',
                  stacked: true,
                },
              ],
            },
          },
        },
      );
  }

  static renderRow(
    name,
    current,
    previous,
    totalCurrent,
    totalPrevious,
    id,
    isPurchasesByProduct,
  ) {
    const currentPercent = ((current?.total || current) / totalCurrent) * 100;
    const infinity = previous === 0 && (current.total || current) !== 0;
    const increase = getIncrease(current?.total || current, previous) || 0;
    const suffix =
      id !== 'totalPurchasesByProduct' && id !== 'totalOfferedByProduct'
        ? ' €'
        : '';
    const isJersey = {jersey_10: 1, jersey_20: 1, jersey_50: 1};

    return (
      <tr
        key={`${id}-${name}`}
        data-toggle="collapse"
        data-target={`.${id}-${name}`}>
        <td style={{width: '150px '}}>
          {translations[name] || name}
          {isPurchasesByProduct &&
            typeof current === 'object' &&
            isJersey[name] && (
              <div className={`${id}-${name} collapse`}>
                {map(current.details, (_quantity, jerseyName) => (
                  <div key={jerseyName} className="text-right">
                    <br />
                    <b>{jerseyName}</b>
                    <br />
                  </div>
                ))}
              </div>
            )}
        </td>
        <th>
          {isPurchasesByProduct &&
          typeof current === 'object' &&
          isJersey[name] ? (
            <React.Fragment>
              {current.total}
              <div className={`${id}-${name} collapse`}>
                {map(current.details, (quantity, jerseyName) => (
                  <div key={jerseyName} className="text-left">
                    <br />
                    <b>{quantity}</b>
                    <br />
                  </div>
                ))}
              </div>
            </React.Fragment>
          ) : (
            numeral(current).format('0,0')
          )}
          {suffix}
        </th>
        <td style={{width: '150px '}} className="text-center">
          {numeral(currentPercent).format('0')} %
        </td>
        <td style={{width: '150px '}} className="text-center">
          {numeral(previous).format('0,0')}
          {suffix}
        </td>
        <td
          style={{width: '150px '}}
          className={classNames('text-center', {
            'text-green': current > previous,
            'text-red': previous > current,
          })}>
          {infinity ? (
            <span>
              +<span style={{fontSize: '18px'}}>∞</span>
            </span>
          ) : (
            numeral(increase).format('+0')
          )}{' '}
          %
        </td>
      </tr>
    );
  }

  orderTable(table, type) {
    let newTable = cloneDeep(table);

    newTable.current = orderBy(
      map(table.current, (value, key) => ({key, value})),
      v => v.value?.total || v.value,
      [this.state[`order${type}`] || 'desc'],
    );

    return newTable;
  }

  updateGraphTotalCaByPlatform(data) {
    const {lang} = this.state;

    const datasets = [
      {
        label: 'Android',
        backgroundColor: '#ed9728',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'iOS',
        backgroundColor: '#9fc99e',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Seeds',
        backgroundColor: '#819bb7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Stripe',
        backgroundColor: '#dd9189',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
    ];

    map(data, (stat, index) => {
      datasets[0].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalCaByPlatform']['android'], 10),
      });
      datasets[1].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalCaByPlatform']['ios'], 10),
      });
      datasets[2].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalCaByPlatform']['seeds'], 10),
      });
      datasets[3].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalCaByPlatform']['stripe'], 10),
      });
    });

    chart1.data.datasets = datasets;
    chart1.update();
  }

  updateGraphTotalPurchasesByProduct(data) {
    const {lang} = this.state;

    const datasets = [
      {
        label: 'AutoCoach',
        backgroundColor: '#ed9728',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Expert',
        backgroundColor: '#9fc99e',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Jerseys',
        backgroundColor: '#819bb7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Old Jerseys',
        backgroundColor: '#6578b7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Live rating',
        backgroundColor: '#dd9189',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Nanard',
        backgroundColor: '#1052b7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'No ads',
        backgroundColor: '#b72527',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Ultra',
        backgroundColor: '#4a4a4a',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Friday brief',
        backgroundColor: '#1eb6e2',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Old autocoach',
        backgroundColor: '#c7c700',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Bundle 02',
        backgroundColor: '#CF61A7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Extra Player Credit',
        backgroundColor: '#B4E28D',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
    ];

    map(data, (stat, index) => {
      datasets[0].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['autocoach'], 10),
      });
      datasets[1].data.push({
        x: moment(index).format('LL'),
        y:
          parseInt(
            stat[lang]['totalPurchasesByProduct']['bundle08_201809'],
            10,
          ) +
          parseInt(
            stat[lang]['totalPurchasesByProduct']['bundle10_201809'],
            10,
          ) +
          parseInt(stat[lang]['totalPurchasesByProduct']['expert04'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['expert06'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['expert08'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['expert10'], 10),
      });
      datasets[2].data.push({
        x: moment(index).format('LL'),
        y:
          (typeof stat[lang]['totalPurchasesByProduct']['jersey_10'] ===
          'object'
            ? parseInt(
                stat[lang]['totalPurchasesByProduct']['jersey_10'].total,
                10,
              )
            : parseInt(
                stat[lang]['totalPurchasesByProduct']['jersey_10'],
                10,
              )) +
          (typeof stat[lang]['totalPurchasesByProduct']['jersey_20'] ===
          'object'
            ? parseInt(
                stat[lang]['totalPurchasesByProduct']['jersey_20'].total,
                10,
              )
            : parseInt(
                stat[lang]['totalPurchasesByProduct']['jersey_20'],
                10,
              )) +
          (typeof stat[lang]['totalPurchasesByProduct']['jersey_50'] ===
          'object'
            ? parseInt(
                stat[lang]['totalPurchasesByProduct']['jersey_50'].total,
                10,
              )
            : parseInt(stat[lang]['totalPurchasesByProduct']['jersey_50'], 10)),
      });
      datasets[3].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['jersey'], 10),
      });
      datasets[4].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['live_rating'], 10),
      });
      datasets[5].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['nanard'], 10),
      });
      datasets[6].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['no_ads'], 10),
      });
      datasets[7].data.push({
        x: moment(index).format('LL'),
        y:
          parseInt(stat[lang]['totalPurchasesByProduct']['ultra06'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['ultra08'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['ultra10'], 10),
      });
      datasets[8].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['friday_brief'], 10),
      });
      datasets[9].data.push({
        x: moment(index).format('LL'),
        y:
          parseInt(stat[lang]['totalPurchasesByProduct']['autocoach04'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['autocoach06'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['autocoach08'], 10) +
          parseInt(stat[lang]['totalPurchasesByProduct']['autocoach10'], 10),
      });
      datasets[10].data.push({
        x: moment(index).format('LL'),
        y: parseInt(stat[lang]['totalPurchasesByProduct']['bundle_02'], 10),
      });
      datasets[11].data.push({
        x: moment(index).format('LL'),
        y: parseInt(
          stat[lang]['totalPurchasesByProduct']['extra_player_credit'],
          10,
        ),
      });
    });

    chart2.data.datasets = datasets;
    chart2.update();
  }

  changeOrder(type) {
    this.setState({
      [`order${type}`]: this.state[`order${type}`] === 'asc' ? 'desc' : 'asc',
    });
  }

  renderTotalCaByPlatform() {
    const id = 'totalCaByPlatform';
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang][id];

    console.log(table);

    if (!isFetching && table) {
      const sumCurrent = sum(Object.values(table.current));
      const sumPrevious = sum(Object.values(table.previous));

      const infinity = sumPrevious === 0 && sumCurrent !== 0;
      const increase = getIncrease(sumCurrent, sumPrevious) || 0;

      const orderedTable = this.orderTable(table, id);

      return (
        orderedTable && (
          <div id={id} className="mb-4">
            <h3 className="my-0 ml-3">
              Par type de paiement <small className="text-muted">{id}</small>
            </h3>
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th />
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}>
                      Montant
                    </th>
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}
                      className="text-center">
                      %
                    </th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">% S-1</th>
                  </tr>
                </thead>
                <tbody>
                  {map(orderedTable.current, current => {
                    const previous = orderedTable.previous[current.key];

                    return SalesWidget.renderRow(
                      current.key,
                      current.value,
                      previous,
                      sumCurrent,
                      sumPrevious,
                      id,
                    );
                  })}
                  <tr>
                    <td style={{width: '150px '}}>Total</td>
                    <th>{numeral(sumCurrent).format('0,0')} €</th>
                    <td style={{width: '150px '}} className="text-center">
                      100 %
                    </td>
                    <td style={{width: '150px '}} className="text-center">
                      {numeral(sumPrevious).format('0,0')} €
                    </td>
                    <td
                      style={{width: '150px '}}
                      className={classNames('text-center', {
                        'text-green': sumCurrent > sumPrevious,
                        'text-red': sumPrevious > sumCurrent,
                      })}>
                      {infinity ? (
                        <span>
                          <span style={{fontSize: '18px'}}>∞</span>
                        </span>
                      ) : (
                        numeral(increase).format('+0')
                      )}{' '}
                      %
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  renderProductByBuyer() {
    const id = 'totalCustomers';
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang][id];

    if (!isFetching && table) {
      const orderedTable = this.orderTable(table, id);

      return (
        orderedTable && (
          <div id={id} className="mb-4">
            <h3 className="my-0 ml-3">
              Par payeurs <small className="text-muted">{id}</small>
            </h3>
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th />
                    <th className="text-center">Montant</th>
                    <th className="text-center">% activeUsers</th>
                    <th className="text-center">Prix moyen</th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">% S-1</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>totalCustomers</th>
                    <th className="text-center">
                      {numeral(table.current).format('0,0')}
                    </th>
                    <th className="text-center">
                      {numeral(
                        (table.current / data[lang].totalActiveUsers.current) *
                          100,
                      ).format('0,0')}{' '}
                      %
                    </th>
                    <th className="text-center">
                      {round(data[lang].totalCa.current / table.current, 2)} €
                    </th>
                    <th className="text-center">
                      {numeral(table.previous).format('0,0')}
                    </th>
                    <td
                      style={{width: '150px '}}
                      className={classNames('text-center', {
                        'text-green': table.current > table.previous,
                        'text-red': table.previous > table.current,
                      })}>
                      {table.previous === 0 && table.current !== 0 ? (
                        <span>
                          +<span style={{fontSize: '18px'}}>∞</span>
                        </span>
                      ) : (
                        numeral(
                          getIncrease(table.current, table.previous) || 0,
                        ).format('+0')
                      )}{' '}
                      %
                    </td>
                  </tr>
                  <tr>
                    <th>totalBeneficiaryUsers</th>
                    <th className="text-center">
                      {numeral(data[lang].totalBeneficiaryUsers.current).format(
                        '0,0',
                      )}
                    </th>
                    <th className="text-center">
                      {numeral(
                        (data[lang].totalBeneficiaryUsers.current /
                          data[lang].totalActiveUsers.current) *
                          100,
                      ).format('0,0')}{' '}
                      %
                    </th>
                    <th className="text-center">
                      {round(
                        data[lang].totalCa.current /
                          data[lang].totalBeneficiaryUsers.current,
                        2,
                      )}{' '}
                      €
                    </th>
                    <th className="text-center">
                      {numeral(
                        data[lang].totalBeneficiaryUsers.previous,
                      ).format('0,0')}
                    </th>
                    <td
                      style={{width: '150px '}}
                      className={classNames('text-center', {
                        'text-green':
                          data[lang].totalBeneficiaryUsers.current >
                          data[lang].totalBeneficiaryUsers.previous,
                        'text-red':
                          data[lang].totalBeneficiaryUsers.previous >
                          data[lang].totalBeneficiaryUsers.current,
                      })}>
                      {data[lang].totalBeneficiaryUsers.previous === 0 &&
                      data[lang].totalBeneficiaryUsers.current !== 0 ? (
                        <span>
                          +<span style={{fontSize: '18px'}}>∞</span>
                        </span>
                      ) : (
                        numeral(
                          getIncrease(
                            data[lang].totalBeneficiaryUsers.current,
                            data[lang].totalBeneficiaryUsers.previous,
                          ) || 0,
                        ).format('+0')
                      )}{' '}
                      %
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  renderTotalPurchasesByProduct() {
    const id = 'totalPurchasesByProduct';
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang][id];

    if (!isFetching && table) {
      const sumCurrent = sum(map(table.current, v => v.total || v));
      const sumPrevious = sum(map(table.previous, v => v.total || v));
      const infinity =
        data[lang].totalSoldProducts.previous === 0 &&
        data[lang].totalSoldProducts.current !== 0;
      const increase =
        getIncrease(
          data[lang].totalSoldProducts.current,
          data[lang].totalSoldProducts.previous,
        ) || 0;

      const orderedTable = this.orderTable(table, id);

      return (
        orderedTable && (
          <div id={id} className="mb-4">
            <h3 className="my-0 ml-3">
              Par produit <small className="text-muted">{id}</small>
            </h3>
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th />
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}>
                      Nb d'achats
                    </th>
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}
                      className="text-center">
                      %
                    </th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">% S-1</th>
                  </tr>
                </thead>
                <tbody>
                  {map(orderedTable.current, current => {
                    const previous = orderedTable.previous[current.key];

                    return SalesWidget.renderRow(
                      current.key,
                      current.value,
                      previous,
                      sumCurrent,
                      sumPrevious,
                      id,
                      true,
                    );
                  })}
                  <tr>
                    <th>Total</th>
                    <th>
                      {numeral(data[lang].totalSoldProducts.current).format(
                        '0,0',
                      )}
                    </th>
                    <th className="text-center">100%</th>
                    <th className="text-center">
                      {numeral(data[lang].totalSoldProducts.previous).format(
                        '0,0',
                      )}
                    </th>
                    <th className="text-center">
                      {infinity ? (
                        <span>
                          +<span style={{fontSize: '18px'}}>∞</span>
                        </span>
                      ) : (
                        numeral(increase).format('+0')
                      )}{' '}
                      %
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  renderTotalOfferedByProduct() {
    const id = 'totalOfferedByProduct';
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang][id];

    if (!isFetching && table) {
      const sumCurrent = sum(map(table.current, v => v.total || v));
      const sumPrevious = sum(map(table.previous, v => v.total || v));
      const infinity =
        data[lang].totalOfferedProducts.previous === 0 &&
        data[lang].totalOfferedProducts.current !== 0;
      const increase =
        getIncrease(
          data[lang].totalOfferedProducts.current,
          data[lang].totalOfferedProducts.previous,
        ) || 0;

      const orderedTable = this.orderTable(table, id);

      return (
        orderedTable && (
          <div id={id} className="mb-4">
            <h3 className="my-0 ml-3">
              Cadeaux inapp <small className="text-muted">{id}</small>
            </h3>
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th />
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}>
                      Nb d'achats
                    </th>
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}
                      className="text-center">
                      %
                    </th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">% S-1</th>
                  </tr>
                </thead>
                <tbody>
                  {map(orderedTable.current, current => {
                    const previous = orderedTable.previous[current.key];

                    return SalesWidget.renderRow(
                      current.key,
                      current.value,
                      previous,
                      sumCurrent,
                      sumPrevious,
                      id,
                      true,
                    );
                  })}
                  <tr>
                    <th>Total</th>
                    <th>
                      {numeral(data[lang].totalOfferedProducts.current).format(
                        '0,0',
                      )}
                    </th>
                    <th className="text-center">100%</th>
                    <th className="text-center">
                      {numeral(data[lang].totalOfferedProducts.previous).format(
                        '0,0',
                      )}
                    </th>
                    <th className="text-center">
                      {infinity ? (
                        <span>
                          +<span style={{fontSize: '18px'}}>∞</span>
                        </span>
                      ) : (
                        numeral(increase).format('+0')
                      )}{' '}
                      %
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  renderTotalCaByProduct() {
    const id = 'totalCaByProduct';
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang][id];

    if (!isFetching && table) {
      const sumCurrent = sum(Object.values(table.current));
      const sumPrevious = sum(Object.values(table.previous));
      const orderedTable = this.orderTable(table, id);

      return (
        orderedTable && (
          <div id={id} className="mb-4">
            <h3 className="my-0 ml-3">
              Par produit avec cash (hors seed){' '}
              <small className="text-muted">{id}</small>
            </h3>
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th />
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}>
                      Montant
                    </th>
                    <th
                      style={{cursor: 'pointer'}}
                      onClick={() => this.changeOrder(id)}
                      className="text-center">
                      %
                    </th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">% S-1</th>
                  </tr>
                </thead>
                <tbody>
                  {map(orderedTable.current, current => {
                    const previous = orderedTable.previous[current.key];

                    return SalesWidget.renderRow(
                      current.key,
                      current.value,
                      previous,
                      sumCurrent,
                      sumPrevious,
                      id,
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data || this.props.data) {
      this.updateGraphTotalCaByPlatform(nextProps.data.purchases);
      this.updateGraphTotalPurchasesByProduct(nextProps.data.purchases);
    }
  }

  componentDidUpdate(prevState) {
    if (this.props.data && prevState.lang !== this.state.lang) {
      this.updateGraphTotalCaByPlatform(this.props.data.purchases);
      this.updateGraphTotalPurchasesByProduct(this.props.data.purchases);
    }
  }

  render() {
    const {end, start, lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="sales-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-money" /> Chiffre d'Affaires freemium net
            </h3>
          </div>
          <div className="box-body">
            <div className="margin-bottom text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <DateRangePickerWrapper
                  initialStartDate={moment(start)}
                  initialEndDate={moment(end)}
                  minimumNights={0}
                  onDatesChange={({startDate, endDate}) => {
                    this.setState({
                      start: moment(startDate).format('YYYY-MM-DD'),
                      end: moment(endDate).format('YYYY-MM-DD'),
                    });
                  }}
                />
                <button
                  className="btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTotalCaByPlatform()}
          <div
            className={classNames(
              'chart',
              this.props.data ? 'displayGraphs' : 'notDisplayGraphs',
            )}>
            <canvas id="totalCaByPlatform-chart" />
          </div>
          {this.renderProductByBuyer()}
          {this.renderTotalPurchasesByProduct()}
          <div
            className={classNames(
              'chart',
              this.props.data ? 'displayGraphs' : 'notDisplayGraphs',
            )}>
            <canvas id="totalPurchasesByProduct-chart" />
          </div>
          {this.renderTotalCaByProduct()}
          {this.renderTotalOfferedByProduct()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.sales,
  dispatch => ({dispatch}),
)(SalesWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Sales/index.js